import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { AccesoService } from "../acceso/acceso.service";
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: "root",
})

export class NotificacionService {
  //readonly urlBase = environment.rutaBase;
  readonly urlBase = "https://dev.digitalfactoring.net";
  header: HttpHeaders;

  constructor(private http: HttpClient, private accesoService: AccesoService) {
    this.header = new HttpHeaders();
    this.header = this.header.append('Accept', 'application/json');
    this.header =  this.header.append('Authorization', '69aACRKVB1NCOfdWNlDieX1sH'); // Notificacion
    // this.header = this.header.append('Authorization', `eVt0rfF=8zDp98sCWB5B`);
    //this.header = this.header.append('Authorization', `863EOgvVNFYgvVzwEWyvsi6qqX11GNtJN3Mf7kwt`); //Gateway
  }

  // sendSms(data: any) {
  //   let headers = this.header;
  //   /*let headers :  HttpHeaders = new HttpHeaders();
  //   headers =  headers.append('Accept', 'application/json');
  //   headers =  headers.append('Authorization', `eVt0rfF=8zDp98sCWB5B`);*/
  //   return this.http.post(`${this.urlBase}/notificar/sms/`, data, {
  //     headers,
  //   });
  // }

  sendSms(data: any) {
    let headers = this.header;
    // return this.http.post(`${this.urlBase}/notificar/sms/`, data, {headers});
    // console.log("dataxxxx", data);

    return this.http.post("https://dev.digitalfactoring.net/api-notificacion/sms/send",data,{headers});
  }

  sendEmail(data: any) {
    let headers = this.header;
    /*let headers: HttpHeaders = new HttpHeaders();
    headers = headers.append('Accept', 'application/json');
    headers = headers.append('Authorization', `eVt0rfF=8zDp98sCWB5B`);*/
    // return this.http.post(`${this.urlBase}/notificar/mail/`, data, {headers});
    return this.http.post("https://dev.digitalfactoring.net/api-notificacion/email/send",data,{headers});
  }
}
